import script from "./MoneyReceiptForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyReceiptForm.vue?vue&type=script&setup=true&lang=js"

import "./MoneyReceiptForm.vue?vue&type=style&index=0&id=7c63c111&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c63c111"]])

export default __exports__